import { render, staticRenderFns } from "./RareDivider.vue?vue&type=template&id=b6a0c37a&scoped=true"
import script from "./RareDivider.vue?vue&type=script&lang=js"
export * from "./RareDivider.vue?vue&type=script&lang=js"
import style0 from "./RareDivider.vue?vue&type=style&index=0&id=b6a0c37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a0c37a",
  null
  
)

export default component.exports